import { Groups } from 'interfaces/groups';
import { useGetRequest } from './../utils/useGetRequest';

const useGetAllGroups = (page: number, pageSize: number) => {
  const [{ data, error, loading: isLoading }, execute] = useGetRequest<Groups>({
    path: `v1/groups?page=${page}&size=${pageSize}`, useRouteIssuer: true
  });

  return {
    groups: data?.data,
    execute,
    pageInfo: {
      size: data?.meta?.size,
      page: data?.meta?.page,
      total: data?.meta?.size,
    },
    isLoading,
    isError: error,
  };
};

export default useGetAllGroups;
